import {
  ADD_RENEWAL_PRICE,
  SET_RENEWAL_PRICE,
} from "../actionTypes/renewalPrices";

const initialState = { items: [] };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RENEWAL_PRICE:
      return {
        ...state,
        items: action.payload,
      };
    case ADD_RENEWAL_PRICE:
      return {
        ...state,
        items: [...state, action.payload],
      };
    default:
      return state;
  }
};

export default reducer;
